import { StatusTag } from '@/components/shared/statusTag';

export function ClassificationChip({
  label,
  status,
}: {
  label: string;
  status: 'on' | 'off';
}) {
  const statusValue = status === 'on' ? 'active' : 'inactive';

  const icon =
    status === 'on'
      ? 'material-symbols-motion-play-outline-rounded'
      : 'mdi-stop-circle-outline';

  return <StatusTag status={statusValue} label={label} icon={icon} />;
}
